<template>
  <stepper
    class="redeem-stepper"
    :currentStep="currentStep"
    :steps="[{ name: 'conta' }, { name: 'cliente SKY' }, { name: 'feito!' }]"
  />
</template>

<script>
export default {
  name: 'redeem-stepper',
  props: {
    currentStep: Number
  }
}
</script>
